import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Col, Container, Row, Badge, Card, CardBody,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import ModalForm from '../../shared/components/form/Modal';
import StudentReviewRequestForm from './StudentReviewRequestForm';
import {
  deleteExam,
} from '../../redux/actions/examActions';
import {
  fetchMyExams,
  getFormData,
} from '../../redux/actions/inscripcionExamenActions';
import {
  createExamReviewRequest,
  getMyExamReviewRequests,
} from '../../redux/actions/examReviewRequestActions';
import {
  obtenerMisDerechos,
} from '../../redux/actions/studentSubjectsActions';
import Confirm from '../../shared/components/Confirm';
import { createErrorMessage, createSuccessMessage, createWarningMessage } from '../../helpers/notification';
import { Calificaciones } from '../../constants/enums';
import TooltipItem from '../../shared/components/TooltipItem';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { dateDDMMYYHHMMFormat, dateMMYYFormat, dateTimeFormat } from '../../helpers/dateFormat';
import simplifyCurriculumName from '../../helpers/stringFormat';

class ExamsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 100,
      totalItemsCount: 0,
      items: [],
      derechos: [],
      filters: { id: 20 },
      estadoExamen: [],
      showReviewModal: false,
      selectedExamReview: null,
      motivoReclamo: '',
      reviewRequestsLoaded: false,
      claimedReviewByInscriptionId: {},
      // map inscripcionExamenId -> respuestaDocente (string or null)
      claimedReviewResponseByInscripcionId: {},
      // map inscripcionExamenId -> estado (0,1,2)
      claimedReviewStatusByInscripcionId: {},
    };
    this.columns = [
      {
        key: 'materia',
        name: 'Materia',
        search: true,
        format: ({
          id, estadoExamen, codMateria, materia,
        }) => this.getLabelEstado({ id, estadoExamen, materia: `${codMateria}-${materia}` }),
      },
      {
        key: 'malla',
        name: 'Malla',
        search: true,
        format: ({ malla }) => simplifyCurriculumName(malla),
      },
      {
        key: 'estadoExamen',
        name: 'Estado',
        search: true,
        visible: false,
        type: 'select',
        searchProps: {
          options: this.getStates,
          isMulti: true,
        },
      },
      {
        key: 'semestre',
        name: 'Semestre',
        search: false,
        format: row => `${row.semestre}º`,
      },
      {
        key: 'fechaExamen',
        name: 'Fecha Examen',
        search: false,
        type: 'date',
        width: '110px',
        format: row => dateMMYYFormat(row.fechaExamen),
      },
      {
        key: 'fechaInscripcion',
        name: 'Inscripción',
        search: false,
        type: 'date',
        width: '110px',
        format: row => dateMMYYFormat(row.fechaInscripcion),
      },
      {
        key: 'esRecuperatorio',
        name: 'Instancia',
        search: false,
        className: 'text-center',
        format: ({ id, instancia }) => {
          let color = 'danger';
          if (instancia.value === 1) {
            color = 'info';
          }

          if (instancia.value === 0) {
            color = 'success';
          }

          return (
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              {
                <button key={`${id}_${instancia.value}`} type="button" className="action-button" tabIndex="-1">
                  <TooltipItem
                    id={`instancia_${id}_${instancia.value}`}
                    value={instancia.label}
                    label={instancia.label}
                    key={`instancia_${id}_${instancia.value}`}
                    color={color}
                  />
                </button>
              }
            </span>
          );
        },
      },
      {
        key: 'porcentajePP', name: 'PP', className: 'text-center', search: false,
      },
      {
        key: 'porcentajePF', name: 'PF', className: 'text-center', search: false,
      },
      {
        key: 'porcentajePC', name: 'PC', className: 'text-center', search: false,
      },
      {
        key: 'calificacion',
        name: 'Calificación',
        search: false,
        className: 'text-center',
        format: ({ id, calificacion }) => this.showScore({
          id,
          calificacion: Calificaciones.find(c => c.value === calificacion) || {},
        }),
      },
      {
        key: 'fechaAtencionReclamos',
        name: 'Fecha de atendimiento',
        search: false,
        width: '180px',
        format: row => (row.fechaAtencionReclamos ? (
          <span>{dateDDMMYYHHMMFormat(row.fechaAtencionReclamos)}</span>
        ) : (
          <span className="text-muted">No configurada</span>
        )),
      },
      {
        key: 'ventanaReclamo',
        name: 'Periodo para solicitar revisión',
        search: false,
        width: '280px',
        format: row => this.renderReviewWindow(row),
      },
      { key: 'actions', name: 'Revisión', width: '180px' },
    ];
    this.actions = [
      {
        key: 'review-request',
        icon: row => this.getReviewRequest(row),
        callback: row => this.handleOpenReviewModal(row),
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.fetchMyExams(page, pageSize);
    this.loadMisDerechos();
    this.fetchFormData();
    this.loadMyReviewRequests();
  }

  loadMyReviewRequests = () => {
    getMyExamReviewRequests(null, {
      onSuccess: (reviewRequests) => {
        const claimedReviewByInscriptionId = {};
        const claimedReviewResponseByInscripcionId = {};
        const claimedReviewStatusByInscripcionId = {};
        (reviewRequests || []).forEach((reviewRequest) => {
          if (reviewRequest && reviewRequest.inscripcionExamenId) {
            const {
              inscripcionExamenId,
              respuestaDocente,
              estado,
            } = reviewRequest;

            claimedReviewByInscriptionId[inscripcionExamenId] = true;
            claimedReviewResponseByInscripcionId[inscripcionExamenId] = (
              respuestaDocente || null
            );
            claimedReviewStatusByInscripcionId[inscripcionExamenId] = (
              typeof estado !== 'undefined' ? estado : null
            );
          }
        });

        this.setState({
          reviewRequestsLoaded: true,
          claimedReviewByInscriptionId,
          claimedReviewResponseByInscripcionId,
          claimedReviewStatusByInscripcionId,
        });
      },
    });
  };

  getClaimedReviewResponse = (exam) => {
    const { claimedReviewResponseByInscripcionId } = this.state;
    if (!exam || !claimedReviewResponseByInscripcionId) return null;
    return claimedReviewResponseByInscripcionId[exam.id] || null;
  };

  getClaimedReviewStatus = (exam) => {
    const { claimedReviewStatusByInscripcionId } = this.state;
    if (!exam || !claimedReviewStatusByInscripcionId) return null;
    return claimedReviewStatusByInscripcionId[exam.id] || null;
  };

  hasValidReviewWindow = (exam) => {
    if (!exam || !exam.estadoExamen) {
      return false;
    }

    // Permitir solicitud de revisión en estado Sellado (1) o ConfirmarNotas (4)
    const allowedStates = [1, 4];
    if (!allowedStates.includes(exam.estadoExamen.value)) {
      return false;
    }

    if (!exam.fechaInicioReclamo || !exam.fechaFinReclamo) {
      return false;
    }

    const now = new Date();
    const from = new Date(exam.fechaInicioReclamo);
    const to = new Date(exam.fechaFinReclamo);
    return now >= from && now <= to;
  };

  hasReviewRequest = (exam) => {
    const { reviewRequestsLoaded, claimedReviewByInscriptionId } = this.state;
    if (!reviewRequestsLoaded || !exam) {
      return false;
    }

    return !!claimedReviewByInscriptionId[exam.id];
  };

  canRequestReview = (exam) => {
    if (!this.hasValidReviewWindow(exam)) {
      return false;
    }

    return !this.hasReviewRequest(exam);
  };

  getReviewActionClassName = (exam) => {
    if (this.canRequestReview(exam)) {
      return 'btn-primary';
    }

    if (this.hasReviewRequest(exam)) {
      return 'btn-outline-secondary';
    }

    return 'btn-outline-warning';
  };

  getReviewActionDisabledClass = exam => (this.canRequestReview(exam) ? '' : 'disabled');

  getReviewActionLabel = (exam) => {
    if (this.hasReviewRequest(exam)) {
      // if professor put it in review show 'En revisión'
      const status = this.getClaimedReviewStatus(exam);
      if (status === 1) return 'En revisión';
      // if teacher already responded show 'Resuelta'
      const respuesta = this.getClaimedReviewResponse(exam);
      return respuesta ? 'Resuelta' : 'Enviado';
    }

    if (this.canRequestReview(exam)) {
      return 'Solicitar';
    }

    return 'No disponible';
  };

  renderReviewWindow = (exam) => {
    const windowText = this.getReviewWindowText(exam);
    if (!windowText) {
      return <span className="text-muted">No configurada</span>;
    }

    return (
      <span className={this.isReviewWindowActive(exam) ? 'text-success' : 'text-muted'}>
        {windowText}
      </span>
    );
  };

  getReviewWindowText = (exam) => {
    if (!exam.fechaInicioReclamo || !exam.fechaFinReclamo) {
      return '';
    }

    return `${dateDDMMYYHHMMFormat(exam.fechaInicioReclamo)} - ${dateDDMMYYHHMMFormat(
      exam.fechaFinReclamo,
    )}`;
  };

  isReviewWindowActive = (exam) => {
    if (!exam.fechaInicioReclamo || !exam.fechaFinReclamo) {
      return false;
    }

    const from = new Date(exam.fechaInicioReclamo);
    const to = new Date(exam.fechaFinReclamo);
    const now = new Date();
    return now >= from && now <= to;
  };

  renderExamCard = exam => (
    <Col xs={12} key={`exam-card-${exam.id}`} className="pb-3">
      <Card outline color="primary" className="card-subject pb-0">
        <CardBody
          className={[
            'summary-card',
            `summary-card--${exam.estadoExamen && exam.estadoExamen.value === 1 ? 'success' : 'info'}`,
          ].join(' ')}
        >
          <div className="summary-card__body checklist-card">
            <h4 className="summary-card__title" style={{ marginBottom: '0.35rem' }}>
              {`${exam.codMateria}-${exam.materia}`}
            </h4>
            <em style={{ fontSize: '12px', color: 'slategray' }}>
              {`${simplifyCurriculumName(exam.malla)} · ${exam.semestre}º semestre`}
            </em>
            <hr />

            <Row dir="ltr" className="summary-card__item">
              <Col xs={12}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                  <span><strong>Estado:</strong> {exam.estadoExamen ? exam.estadoExamen.label : '-'}</span>
                  <Row>
                    <Col xs={6}>
                      <span><strong>Malla:</strong> {simplifyCurriculumName(exam.malla)}</span>
                    </Col>
                    <Col xs={6}>
                      <span><strong>Semestre:</strong> {`${exam.semestre}º`}</span>
                    </Col>
                  </Row>
                  <span><strong>Fecha examen:</strong> {dateMMYYFormat(exam.fechaExamen)}</span>
                  <span><strong>Inscripción:</strong> {dateMMYYFormat(exam.fechaInscripcion)}</span>
                  <span><strong>Instancia:</strong> {exam.instancia ? exam.instancia.label : '-'}</span>
                  <span>
                    <strong>Fecha de atendimiento:</strong>{' '}
                    {exam.fechaAtencionReclamos ? dateTimeFormat(exam.fechaAtencionReclamos) : 'No configurada'}
                  </span>
                  <span>
                    <strong>Periodo para solicitar revisión:</strong>{' '}
                    {this.getReviewWindowText(exam) || 'No configurada'}
                  </span>
                  <span>
                    <strong>Porcentaje</strong>{' '}
                    {`PP:${exam.porcentajePP || 0}% · PF:${exam.porcentajePF || 0}% · PC:${exam.porcentajePC || 0}%`}
                  </span>
                  <span>
                    <strong>Calificación:</strong>{' '}
                    {(Calificaciones.find(c => c.value === exam.calificacion) || {}).label || '-'}
                  </span>
                </div>
              </Col>
            </Row>

            <Row dir="ltr" className="summary-card__item">
              <Col xs={12}>
                <span title={this.getReviewRequestTitle(exam)}>
                  <button
                    type="button"
                    className={`btn btn-sm ${this.getReviewActionClassName(exam)}`}
                    disabled={!this.canRequestReview(exam)}
                    onClick={() => this.handleOpenReviewModal(exam)}
                  >
                    {this.getReviewActionLabel(exam)}
                  </button>
                </span>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );

  getReviewRequestTitle = (exam) => {
    if (this.hasReviewRequest(exam)) {
      const respuesta = this.getClaimedReviewResponse(exam);
      const status = this.getClaimedReviewStatus(exam);
      if (respuesta) return respuesta;
      if (status === 1) return 'En revisión';
      return 'Revisión ya solicitado';
    }

    if (!this.hasValidReviewWindow(exam)) {
      return 'Revisión no disponible';
    }

    return 'Solicitar revisión';
  };

  getReviewRequest = (row) => {
    const hasReview = this.hasReviewRequest(row);
    const validWindow = this.hasValidReviewWindow(row);

    if (hasReview || !validWindow) {
      // case: no review requested and window not configured -> show 'No disponible'
      if (!hasReview && !validWindow) {
        return (
          <span style={{ display: 'flex', justifyContent: 'center' }}>
            <button key={`${row.id}`} type="button" className="action-button" tabIndex="-1">
              <TooltipItem
                id={`Tool-tip-Item-${row.id}`}
                value={this.getReviewActionLabel(row)}
                label="No disponible"
                key={`${row.id}`}
                color="secondary"
              />
            </button>
          </span>
        );
      }

      const status = this.getClaimedReviewStatus(row);
      const respuesta = this.getClaimedReviewResponse(row);
      let color = 'secondary';
      if (status === 1) {
        color = 'info';
      } else if (respuesta) {
        color = 'success';
      }

      let label = 'Revisión ya solicitado';
      if (respuesta) {
        label = respuesta;
      } else if (status === 1) {
        label = 'En revisión';
      }

      return (
        <span style={{ display: 'flex', justifyContent: 'center' }}>
          {
            <button key={`${row.id}`} type="button" className="action-button" tabIndex="-1">
              <TooltipItem
                id={`Tool-tip-Item-${row.id}`}
                value={this.getReviewActionLabel(row)}
                label={label}
                key={`${row.id}`}
                color={color}
              />
            </button>
          }
        </span>
      );
    }

    return (
      <button
        type="button"
        className={[
          'btn',
          'btn-sm',
          this.getReviewActionClassName(row),
          this.getReviewActionDisabledClass(row),
        ].join(' ')}
        title={this.getReviewRequestTitle(row)}
      >
        <span className="fa fa-hand-paper-o" title={this.getReviewActionLabel(row)} />
        {' '}
        {this.getReviewActionLabel(row)}
      </button>
    );
  };

  handleOpenReviewModal = (exam) => {
    if (this.hasReviewRequest(exam)) {
      createWarningMessage('Ya tienes una revisión registrada para este examen.');
      return;
    }

    if (!this.canRequestReview(exam)) {
      createWarningMessage(
        'No puedes solicitar revisión a este examen. Verifica estado y el periodo para solicitar revisión.',
      );
      return;
    }

    this.setState({
      showReviewModal: true,
      selectedExamReview: exam,
      motivoReclamo: '',
    });
  };

  handleCloseReviewModal = () => {
    this.setState({
      showReviewModal: false,
      selectedExamReview: null,
      motivoReclamo: '',
    });
  };

  handleBlurMotivoReclamo = (name, event) => {
    let value = '';
    if (typeof name === 'string' && name !== 'motivoReclamo') {
      value = '';
    }

    if (typeof event === 'string') {
      value = event;
    } else if (event && event.target && typeof event.target.value !== 'undefined') {
      const { value: eventValue } = event.target;
      value = eventValue;
    }

    this.setState({ motivoReclamo: value });
  };

  handleCreateReviewRequest = () => {
    const {
      selectedExamReview,
      motivoReclamo,
    } = this.state;

    this.setState({ loading: true });

    createExamReviewRequest({
      inscripcionExamenId: selectedExamReview.id,
      motivoReclamo,
    }, {
      onSuccess: () => {
        this.setState(prev => ({
          reviewRequestsLoaded: true,
          claimedReviewByInscriptionId: {
            ...prev.claimedReviewByInscriptionId,
            [selectedExamReview.id]: true,
          },
        }), () => {
          createSuccessMessage('Solicitud de revisión enviada correctamente.');
          this.handleCloseReviewModal();
          const { page, pageSize, filters } = this.state;
          this.fetchMyExams(page, pageSize, filters);
        });
      },
      onError: (error) => {
        this.setState({ loading: false });
        if (error && error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Error al intentar crear la solicitud de revisión.');
        }
      },
    });
  };

  fetchMyExams = (page, pageSize, filters) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });
    fetchMyExams({
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: ({ items, totalItemsCount }) => {
        this.setState({
          loading: false,
          items,
          totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de exámenes');
      },
    });
  }

  loadMisDerechos = () => {
    this.setState({ loading: true });
    obtenerMisDerechos({
      pageInfo: {
        page: 1,
        pageSize: 1,
      },
      onSuccess: ({ items }) => {
        this.setState({
          loading: false,
          derechos: items,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de exámenes disponibles');
      },
    });
  };

  fetchFormData = () => {
    this.setState({ loading: true });
    getFormData({
      onSuccess: ({
        estadoExamen,
      }) => this.setState({
        loading: false,
        estadoExamen,
      }),
      onError: () => {
        this.setState({ loading: false });
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleDeleteExam = (examen) => {
    const name = `${examen.materia.codigo}- ${examen.materia.nombre}`;
    Confirm({
      title: 'Borrar examen',
      question: `Estás seguro que deseas eliminar el examen ${name}?`,
      yesLabel: 'Si, Borrar examen',
      noLabel: 'No, Volver',
      onConfirm: () => {
        this.setState({ loading: true });

        deleteExam(examen.id, {
          onSuccess: () => {
            this.setState({ loading: false });
            createSuccessMessage('Examen borrado exitosamente');
            const { page, pageSize } = this.state;
            this.fetchMyExams(page, pageSize);
          },
          onError: (error) => {
            this.setState({ loading: false });
            if (error && error.status === 404) {
              createErrorMessage('El examen no existe');
            } else {
              createErrorMessage('Error al intentar borrar el examen');
            }
          },
        });
      },
    });
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.fetchMyExams(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.fetchMyExams(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.fetchMyExams(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  showScore = ({ id, calificacion }) => (
    <span style={{ display: 'flex', justifyContent: 'center' }}>
      {
        <button key={`${id}_${calificacion.value}`} type="button" className="action-button" tabIndex="-1">
          <TooltipItem
            id={`${id}_${calificacion.value}`}
            value={calificacion.label}
            label={calificacion.label}
            key={`${id}_${calificacion.value}`}
            color={calificacion.color}
          />
        </button>
      }
    </span>
  );

  getLabelEstado = ({ id, materia, estadoExamen = {} }) => (
    <span style={{ display: 'flex', justifyContent: 'start', fontSize: '1rem' }}>
      <button key={`button-label-estado-${id}`} type="button" className="action-button" tabIndex="-1">
        <h4 key={`h4-label-estado-${id}`}>
          <Badge
            key={`badge-label-estado-${id}`}
            color={estadoExamen.value === 0 ? 'info' : 'success'}
          >
            {materia}
          </Badge>
        </h4>

      </button>
    </span>
  );

  getLabelEstados = () => (
    <Row dir="ltr" style={{ marginBottom: '1rem' }}>
      <Col sm={12}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <h4 style={{ textAlign: 'end' }}>Estados:</h4>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="info"
            pill
          >
            Activo
          </Badge>
          <Badge
            style={{ fontSize: '0.81rem', paddingTop: '0.45rem' }}
            color="success"
            pill
          >
            Sellado
          </Badge>
        </div>
      </Col>
    </Row>
  );

  getStates = () => {
    const { estadoExamen } = this.state;
    return estadoExamen;
  };

  render() {
    const {
      loading,
      items,
      derechos = [],
      page,
      pageSize,
      totalItemsCount,
      filters,
      showReviewModal,
      selectedExamReview,
    } = this.state;

    if (loading) {
      return (
        <LoadingSpinner />
      );
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Mis ex&aacute;menes</h3>
            <div
              className="card__title"
              style={{
                display: 'flex',
                rowGap: '1rem',
                flexWrap: 'wrap',
              }}
            >
              {
                derechos.length > 0 ? (
                  <>
                    <Link className="btn btn-primary" to="/pages/student-exams/inscription">
                      <i className="fa fa-plus" /> Inscripci&oacute;n a examen
                    </Link>
                    {' '}
                  </>
                ) : null
              }
              <Link className="btn btn-outline-info" to="/pages/student-exams/review-requests">
                <i className="fa fa-list" /> Mis solicitudes de revisión
              </Link>
            </div>
          </Col>
        </Row>
        {this.getLabelEstados()}
        <Row className="d-md-none">
          {items.map(this.renderExamCard)}
        </Row>

        <Row className="d-none d-md-flex">
          <DataTable
            title="Historial de ex&aacute;menes"
            columns={this.columns}
            items={items}
            onChangePage={this.onChangePage}
            page={page}
            pageSize={pageSize}
            totalItemsCount={totalItemsCount}
            getGridActions={key => this.getGridActions(key)}
            onSubmit={this.onDataTableSubmit}
            onClearFilters={this.onDataTableClearFilters}
            initialValues={filters}
            enableReinitialize
          />
        </Row>
        <ModalForm
          header
          buttonToolbar
          colored={false}
          color="primary"
          title="Solicitar revisión"
          isOpen={showReviewModal}
          toggle={this.handleCloseReviewModal}
          onOk={this.handleCreateReviewRequest}
          onCancel={this.handleCloseReviewModal}
          okButtonText="Solicitar revisión"
          cancelButtonText="Cancelar"
          size="lg"
        >
          <StudentReviewRequestForm
            key={selectedExamReview ? selectedExamReview.id : 'review-request'}
            examLabel={selectedExamReview
              ? `${selectedExamReview.codMateria}-${selectedExamReview.materia}`
              : ''}
            reviewWindowLabel={selectedExamReview ? this.getReviewWindowText(selectedExamReview) : ''}
            onBlur={this.handleBlurMotivoReclamo}
          />
        </ModalForm>
      </Container>
    );
  }
}

export default withRouter(ExamsContainer);
